import { Component, OnInit, AfterViewInit, Input, ViewChild, Renderer2, ElementRef, ChangeDetectionStrategy } from '@angular/core';

import { WrapperService } from '../wrapper/wrapper.service';

import { LayoutStore } from '../layout.store';

import { SidebarRightService } from './sidebar-right.service';
export class SidebarRightComponent implements OnInit, AfterViewInit {
public layout: string;
public sidebarHeight: number;
private skin: string;
private windowInnerHeight: number;
private isSidebarRightOverContent: boolean;
private isSidebarRightCollapsed: boolean;
public sidebarContentElement: ElementRef;
/**
 * @param {?} elementRef
 * @param {?} renderer2
 * @param {?} layoutStore
 * @param {?} sidebarRightService
 * @param {?} wrapperService
 */
constructor(
private elementRef: ElementRef,
private renderer2: Renderer2,
private layoutStore: LayoutStore,
private sidebarRightService: SidebarRightService,
private wrapperService: WrapperService
  ) {}
/**
 * \@method ngOnInit
 * @return {?}
 */
ngOnInit() {
    this.renderer2.addClass(this.elementRef.nativeElement, 'control-sidebar');

    this.layoutStore.isSidebarRightCollapsed.subscribe(value => {
      this.isSidebarRightCollapsed = value;
      if(!value) {
        this.renderer2.addClass(this.elementRef.nativeElement, 'control-sidebar-open');
        if(!this.isSidebarRightOverContent) {
          this.renderer2.addClass(this.wrapperService.wrapperElementRef.nativeElement, 'control-sidebar-open');
        }
      } else {
        this.renderer2.removeClass(this.elementRef.nativeElement, 'control-sidebar-open');
        if(!this.isSidebarRightOverContent) {
          this.renderer2.removeClass(this.wrapperService.wrapperElementRef.nativeElement, 'control-sidebar-open');
        }
      }
    });

    this.layoutStore.isSidebarRightOverContent.subscribe((value: boolean) => {
      this.isSidebarRightOverContent = value;
      if(!this.isSidebarRightCollapsed) {
        if(value) {
          this.renderer2.removeClass(this.wrapperService.wrapperElementRef.nativeElement, 'control-sidebar-open');
        } else {
          this.renderer2.addClass(this.wrapperService.wrapperElementRef.nativeElement, 'control-sidebar-open');
        }
      }
    });

    this.layoutStore.sidebarRightSkin.subscribe((value: string) => {
      if(this.skin !== value) {
        this.renderer2.removeClass(this.elementRef.nativeElement, `control-sidebar-${this.skin}`);
      }
      this.skin = value;
      this.renderer2.addClass(this.elementRef.nativeElement, `control-sidebar-${value}`);
    });
  }
/**
 * \@method ngAfterViewInit
 * @return {?}
 */
ngAfterViewInit() {
    this.sidebarRightService.elementRef = this.sidebarContentElement;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-layout-sidebar-right',
  template: `
    <div #sidebarContentElement class="control-sidebar-content">
      <ng-content></ng-content>
    </div>
    <div class="control-sidebar-bg"></div>
  `,
  styles: [`
    :host {
      display: block;
      height: 100%;
    }

    .control-sidebar-bg {
      z-index: -1;
    }

    /deep/ .tab-content {
      padding: 10px 15px;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush

}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: LayoutStore, },
{type: SidebarRightService, },
{type: WrapperService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'sidebarContentElement': [{ type: ViewChild, args: ['sidebarContentElement', ] },],
};
}

function SidebarRightComponent_tsickle_Closure_declarations() {
/** @type {?} */
SidebarRightComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidebarRightComponent.ctorParameters;
/** @type {?} */
SidebarRightComponent.propDecorators;
/** @type {?} */
SidebarRightComponent.prototype.layout;
/** @type {?} */
SidebarRightComponent.prototype.sidebarHeight;
/** @type {?} */
SidebarRightComponent.prototype.skin;
/** @type {?} */
SidebarRightComponent.prototype.windowInnerHeight;
/** @type {?} */
SidebarRightComponent.prototype.isSidebarRightOverContent;
/** @type {?} */
SidebarRightComponent.prototype.isSidebarRightCollapsed;
/** @type {?} */
SidebarRightComponent.prototype.sidebarContentElement;
/** @type {?} */
SidebarRightComponent.prototype.elementRef;
/** @type {?} */
SidebarRightComponent.prototype.renderer2;
/** @type {?} */
SidebarRightComponent.prototype.layoutStore;
/** @type {?} */
SidebarRightComponent.prototype.sidebarRightService;
/** @type {?} */
SidebarRightComponent.prototype.wrapperService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
